/* One intentional, same-tab handoff. No account identifiers or calendar access tokens. */
(function () {
  'use strict';
  const KEY = 'lig-calendar-gift-v1', TTL = 30 * 60 * 1000;
  const SCENES = {
    ornament: ['truck', 'sweater', 'christmas_morning', 'gift_box'],
    card: ['boat-parade', 'harbor', 'mountain-lodge', 'california-coast', 'texas-ranch', 'brownstone'],
    mug: ['boat-parade', 'harbor', 'mountain-lodge', 'california-coast', 'texas-ranch', 'brownstone'],
    apparel: ['christmas-tree-run'],
  };
  function valid(raw) {
    if (!raw || !SCENES[raw.kind]?.includes(raw.scene)) return null;
    if (!Number.isFinite(raw.at) || raw.at > Date.now() + 1000 || Date.now() - raw.at > TTL) return null;
    if (typeof raw.photo !== 'string' || raw.photo.length > 2800000 || !/^data:image\/(jpeg|png|webp);base64,[A-Za-z0-9+/]+={0,2}$/.test(raw.photo)) return null;
    if (typeof raw.name !== 'string' || !raw.name.trim() || raw.name.length > 80) return null;
    return { kind: raw.kind, scene: raw.scene, name: raw.name.trim(), photo: raw.photo, at: raw.at, returnUrl: '/pages/your-dog-calendar' };
  }
  function save(raw) {
    const item = valid(raw);
    if (!item) throw Error('We could not carry this photo into the gift maker. Please try again.');
    try { sessionStorage.setItem(KEY, JSON.stringify(item)); }
    catch { throw Error('Your browser could not save the photo for the next page. Please allow site storage and try again.'); }
    return true;
  }
  function consume(kind) {
    try {
      const raw = JSON.parse(sessionStorage.getItem(KEY) || 'null'), item = valid(raw);
      if (!item) { sessionStorage.removeItem(KEY); return null; }
      if (item.kind !== kind) return null;
      sessionStorage.removeItem(KEY);
      return item;
    } catch { try { sessionStorage.removeItem(KEY); } catch {} return null; }
  }
  function toFile(photo) {
    if (typeof photo !== 'string' || photo.length > 2800000 || !/^data:image\/(jpeg|png|webp);base64,[A-Za-z0-9+/]+={0,2}$/.test(photo)) throw Error('That photo could not be read.');
    const mime = photo.slice(5, photo.indexOf(';')), bytes = atob(photo.split(',')[1]);
    const data = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) data[i] = bytes.charCodeAt(i);
    return new File([data], 'calendar-dog.' + (mime === 'image/jpeg' ? 'jpg' : mime.split('/')[1]), { type: mime });
  }
  window.LigDogHandoff = Object.freeze({ save, consume, toFile });
})();
